import * as React from "react"
import Section from "../../../core/layout/main/section/Section"
import * as classNames from "./BlogArticlesSelectionBannerSection.module.scss"
import { Swiper, SwiperSlide } from "swiper/react"
import ArticleCardBlock from "../blocks/article-card/ArticleCardBlock"
import { articleUrl } from "../../../../utils/routeLib"
const BlogArticlesSelectionBannerSection = ({ cardNumber, articles }) => {
  return (
    <Section
      container={"large"}
      className={classNames.section}
    >
      <Swiper
        slidesPerView={"auto"}
        spaceBetween={44}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 50 },
          800: { slidesPerView: 2, spaceBetween: 80 },
          1024: { slidesPerView: cardNumber },
        }}
        className={classNames.swiperSection}
      >
        {articles.map((art, index) => (
          <SwiperSlide
            key={`article_${index}`}
            style={{ marginRight: "44px" }}
          >
            <ArticleCardBlock
              articles={art}
              url={articleUrl(art)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Section>
  )
}

export const name = "BlogArticlesSelectionBannerSection"

export const init = (componentData, pageContext) => {
  // const cardNbr=parseFloat(componentData.cardNumber.toString().replace(".",","));

  const cardNbr = componentData.cardNumber
  const articles =
    componentData.articles?.length === 0 ? [] : componentData.articles.data

  return (
    <BlogArticlesSelectionBannerSection
      key={componentData.id}
      cardNumber={cardNbr}
      articles={articles}
    />
  )
}

export default BlogArticlesSelectionBannerSection
